import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'error-page',
    templateUrl: './errorPage.component.html',
    styleUrls: ['./errorPage.component.css'],
    standalone: false
})
export class ErrorPageComponent {
    @Input() public message: string;
    @Input() public backLink: string;
    @Input() public launcherEnabled: boolean;
    @Input() public backLinkEnabled: boolean;
    @Input() public backLinkText: string;

    constructor(private activatedRoute: ActivatedRoute, private router: Router) {
        this.message = activatedRoute.snapshot.data["errorMessage"] || "";
        this.backLink = activatedRoute.snapshot.data["backLink"] || "/";
        this.launcherEnabled = activatedRoute.snapshot.data["launcherEnabled"] || false;
        this.backLinkEnabled = activatedRoute.snapshot.data["backLinkEnabled"] || false;
        this.backLinkText = activatedRoute.snapshot.data["backLinkText"] || "Volver";

        if (!this.message) {
            this.router.navigate(['home']);
        }
    }
}